module.exports = __webpack_public_path__ + "deals_active.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/menu/deals_active.svg
// module id = 116
// module chunks = 0